
// TODO: move to routes or app?
export const unitcomparePage =
{
  id: -1, // pages that are not templates have a negative id (?)
  path: 'exporteren',
  name: 'Exporteren',
  iconName: 'import_export'
};